function initProductOptions() {
    const optionsContainer = document.querySelector("[data-product-tabs]");
    if (!optionsContainer) return;

    const buttons = Array.from(
        optionsContainer.querySelectorAll("[data-tab-button]"),
    );
    const panels = Array.from(optionsContainer.querySelectorAll("[data-tab-panel]"));

    if (!buttons.length || !panels.length) return;

    const setActiveOption = (tabId) => {
        buttons.forEach((button) => {
            const isActive = button.dataset.tabButton === tabId;
            button.classList.toggle("active", isActive);
            button.setAttribute("aria-pressed", String(isActive));
        });

        panels.forEach((panel) => {
            panel.classList.toggle("active", panel.dataset.tabPanel === tabId);
        });
    };

    buttons.forEach((button) => {
        button.addEventListener("click", () => {
            setActiveOption(button.dataset.tabButton);
        });
    });

    const initialTab =
        optionsContainer.dataset.initialTab || buttons[0].dataset.tabButton;
    setActiveOption(initialTab);
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initProductOptions);
} else {
    initProductOptions();
}
